import React from 'react'
import Aos from 'aos'
import NKS1 from '../../Images/HR/NirbachitKaryasamiti/ArjunRajAdhikari.JPG'
import NKS2 from '../../Images/HR/NirbachitKaryasamiti/BalaramPokhrel.jpg'
import NKS3 from '../../Images/HR/NirbachitKaryasamiti/YaamPrasadSigdel.jpg'
import NKS4 from '../../Images/HR/NirbachitKaryasamiti/RabindraKrishnaShrestha.jpg'
import NKS5 from '../../Images/HR/NirbachitKaryasamiti/FadindraPoudel.jpg'
import NKS6 from '../../Images/HR/NirbachitKaryasamiti/LokPrasadBhattarai.jpg'
import NKS7 from '../../Images/HR/NirbachitKaryasamiti/ChudamaniDulal.jpg'
import NKS8 from '../../Images/HR/NirbachitKaryasamiti/BharatiGuragaiBaral.jpg'
import NKS9 from '../../Images/HR/NirbachitKaryasamiti/BishnuKumariRai.jpg'
import NKS10 from '../../Images/HR/NirbachitKaryasamiti/NageshPokhrel.jpg'
import NKS11 from '../../Images/HR/NirbachitKaryasamiti/AnjanaSangraulaDhakal.jpg'
import NKS12 from '../../Images/HR/NirbachitKaryasamiti/BhaktiPrasadDhakal.jpg'
import NKS13 from '../../Images/HR/NirbachitKaryasamiti/JiwanKhatiwoda.jpg'
import NKS14 from '../../Images/HR/NirbachitKaryasamiti/KesabPrasadPokhrel.jpg'
import NKS15 from '../../Images/HR/NirbachitKaryasamiti/UmeshUpreti.jpg'
import NKS16 from '../../Images/HR/NirbachitKaryasamiti/BinaDhakalSitaula.jpg'
import NKS17 from '../../Images/HR/NirbachitKaryasamiti/PostaKumariShrestha.jpg'
import NKS18 from '../../Images/HR/NirbachitKaryasamiti/MohanChudal.jpg'

const NibartamanKaryaSamiti = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const ComitteeList = [
        {
            id: '1',
            memName: 'अर्जुनराज अधिकारी',
            post: 'अध्यक्ष',
            memImg: NKS1
        },
        {
            id: '2',
            memName: 'बलराम पोखरेल',
            post: 'उपाध्यक्ष',
            memImg: NKS2
        },
        {
            id: '3',
            memName: 'यामप्रसाद सिग्देल',
            post: 'सचिव',
            memImg: NKS3
        },
        {
            id: '4',
            memName: 'रविन्द्रकृष्ण श्रेष्ठ',
            post: 'सहसचिव',
            memImg: NKS4
        },
        {
            id: '5',
            memName: 'फडिन्द्र पौडेल',
            post: 'कोषाध्यक्ष',
            memImg: NKS5
        },
        {
            id: '6',
            memName: 'लोकप्रसाद भट्टराई',
            post: 'सहकोषाध्यक्ष ',
            memImg: NKS6
        },
        {
            id: '7',
            memName: 'चूडामणि दुलाल',
            post: 'सदस्य ',
            memImg: NKS7
        },
        {
            id: '8',
            memName: 'भारती गुरागाईं बराल',
            post: 'सदस्य ',
            memImg: NKS8
        },
        {
            id: '9',
            memName: 'विष्णुकुमारी राई',
            post: 'सदस्य ',
            memImg: NKS9
        },
        {
            id: '10',
            memName: 'नागेश पोखरेल',
            post: 'सदस्य ',
            memImg: NKS10
        },
        {
            id: '11',
            memName: 'अन्जना संग्रौला ढकाल',
            post: 'सदस्य ',
            memImg: NKS11
        },
        {
            id: '12',
            memName: 'भक्तिप्रसाद ढकाल',
            post: 'सदस्य ',
            memImg: NKS12
        },
        {
            id: '13',
            memName: 'जीवन खतिवडा',
            post: 'सदस्य ',
            memImg: NKS13
        },
        {
            id: '14',
            memName: 'केशवप्रसाद पोखरेल',
            post: 'सदस्य ',
            memImg: NKS14
        },
        {
            id: '15',
            memName: 'उमेश उप्रेती',
            post: 'सदस्य ',
            memImg: NKS15
        },
        {
            id: '16',
            memName: 'विना ढकाल सिटौला',
            post: 'सदस्य ',
            memImg: NKS16
        },
        {
            id: '17',
            memName: 'पोष्टकुमार श्रेष्ठ',
            post: 'सदस्य ',
            memImg: NKS17
        },
        {
            id: '18',
            memName: 'मोहन चूडाल',
            post: 'सदस्य ',
            memImg: NKS18
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>प्रथम वार्षिक साधारण सभाबाट निर्वाचित कार्यसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {ComitteeList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='heading1'>
                        <div className='h2' style={{ marginTop: '20px' }}>
                            <h2>लेखा तथा सुपरिवेक्षण समिति</h2><hr />
                        </div>
                    </div>
                    <div className='branches-body'>
                        <div className='card-container'>
                            {/* {FormerBODList.map((item, id) => {
                                return (
                                    <a href={item.path} onClick={() => window.scrollTo({ top: 0 })}>
                                        <div className='card' key={id} style={{ width: '300px' }} data-aos='fade-right'>
                                            <div className='inner'>
                                                <div className='img-holder'>
                                                    <img src={item.Image} alt='formerbod-Image' />
                                                </div>
                                                <div className='detail'>
                                                    <h3>{item.Name}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )
                            })} */}
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default NibartamanKaryaSamiti